var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8341 11.1197C17.9624 11.3071 17.9015 11.5477 17.6942 11.6724L12.2781 14.9312C12.1111 15.0317 11.8889 15.0317 11.7219 14.9312L6.30577 11.6724C6.09854 11.5477 6.03764 11.3071 6.16589 11.1197L11.582 3.20547C11.7695 2.93151 12.2305 2.93151 12.4179 3.20547L17.8341 11.1197ZM12 6.6319L9.09156 10.8818L12 12.6317L14.9084 10.8818L12 6.6319Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4071 20.8096C12.216 21.0635 11.784 21.0635 11.5929 20.8096L6.04094 13.4345C5.89497 13.2406 6.16979 13.0169 6.3871 13.1528L12 16.6615L17.6129 13.1528C17.8302 13.0169 18.105 13.2406 17.9591 13.4345L12.4071 20.8096Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandEthereum);
export default __webpack_public_path__ + "static/media/brand_ethereum.3c2686dfb04d561db7dd83257a4cdebf.svg";
export { ForwardRef as ReactComponent };